import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElioCustomVueFormJsonSchema from "./components/ElioCustomVueFormJsonSchema";
import PrettyPrint from './components/pretty-print';
import './quasar'
import OfferPage from './components/OfferPage.vue';
import ElioJSONSchemaConverter from './JSONSchemaConverter';

Vue.use(ElioJSONSchemaConverter);
Vue.use(VueAxios, axios);
Vue.component('offer-page', OfferPage);
Vue.component("pretty-print", PrettyPrint)
Vue.component('vue-form-json-schema', ElioCustomVueFormJsonSchema);

Vue.config.productionTip = false;

Vue.filter('toCurrency', function (value) {
    if (isNaN(parseFloat(value))) {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(parseFloat(value));
});

var vm = new Vue({
  render: h => h(App),
}).$mount('#app')
